import { store } from 'app/redux/store';
import {
  useGetQuestionnaireByIdQueryState,
  useUpdateQuestionnaireMutation,
} from 'app/services/questionnaires';
import { errorToast, successToast } from 'Components/Notifications';
import { useParams } from 'react-router-dom';

export default function useSaveDraft() {
  const { questionnaireId } = useParams();

  const { data: questionnaireData } = useGetQuestionnaireByIdQueryState(
    questionnaireId!,
  );
  const [updateQuestionnaire, { isLoading, isSuccess }] =
    useUpdateQuestionnaireMutation();

  const saveDraft = () => {
    if (questionnaireData) {
      updateQuestionnaire({
        id: questionnaireId!,
        questionnaire: {
          data: {
            prepareQuestionnaire: store.getState().prepareQuestionnaire,
            taxQuestionnaire: store.getState().taxQuestionnaire,
          },
        },
      }).then((res) => {
        if ('error' in res && res?.error) {
          const error = res?.error;
          errorToast((error as Error)?.message);
        } else {
          successToast('Saved Draft!');
        }
      });
    }
  };

  return { saveDraft, isLoading, isSuccess };
}
